import {fonts} from '../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../utills/pxToRem'

export const adyenCustomStyles = {
    '.adyen-checkout__button__icon,.adyen-checkout-form-instruction, .adyen-checkout__card__brands':
        {
            display: 'none !important'
        },
    '.adyen-checkout__payment-method--selected': {
        background: 'transparent',
        border: 'none'
    },

    '.adyen-checkout__payment-method__details': {
        padding: 0
    },

    '.adyen-checkout__card-input': {
        paddingInline: [pxToRem(10), pxToRem(10), pxToRem(15)]
    },

    '.adyen-checkout__button--pay': {
        borderRadius: 'none',
        fontFamily: fonts.primary,
        height: [pxToRem(35), pxToRem(40)],
        padding: [`${pxToRem(10)} ${pxToRem(20)}`, `${pxToRem(12)} ${pxToRem(20)}`],
        fontWeight: 700,
        textTransform: 'uppercase',
        textAlign: 'center',
        fontSize: [pxToRem(12), pxToRem(14)],
        fontStyle: 'normal',
        lineHeight: pxToRem(13.5),
        letterSpacing: pxToRem(1.5),
        backgroundColor: 'cav_red',
        color: 'white',
        _hover: {bg: 'white', color: 'cav_red', borderColor: 'cav_red', border: '1px solid'},
        _active: {bg: 'white', color: 'cav_red', borderColor: 'cav_red', border: '1px solid'},
        _disabled: {
            _hover: {backgroundColor: 'cav_red !important', color: 'white'}
        }
    },

    '.adyen-checkout__label__text': {
        color: 'black',
        fontSize: [pxToRem(14), pxToRem(14), pxToRem(16)],
        fontWeight: 400,
        letterSpacing: pxToRem(1),
        lineHeight: 'normal',
        paddingBottom: [pxToRem(5), pxToRem(5), pxToRem(10)],
        position: 'relative',
        '&::after': {
            content: "'*'",
            color: 'cav_calltoaction_darkred',
            fontSize: [pxToRem(14), pxToRem(14), pxToRem(16)],
            position: 'absolute',
            top: '-2px'
        }
    },

    '.adyen-checkout__label--focused .adyen-checkout__label__text': {
        color: 'black'
    },

    '.adyen-checkout__input': {
        color: 'black',
        caretColor: 'black',
        fontSize: pxToRem(16),
        height: pxToRem(40),
        border: `${pxToRem(1)} solid black`,
        borderRadius: 0,
        '&:hover, &:focus,  &:active, &:focus:hover, &:active:hover': {
            border: `${pxToRem(1)} solid black`,
            boxShadow: 'none'
        }
    },
    '.apple-pay-button, .adyen-checkout__applepay__button': {
        '-webkit-appearance': '-apple-pay-button !important',
        appearance: '-apple-pay-button !important'
    }
}
